import React from "react";

// Style
import { Container, Image } from "./TopContainerLogin.style";

// Components
import { Languages } from "components/TopContainerLogin/Languages";

export const TopContainerLogin = () => {
  return (
    <Container>
      <Image />
      <Languages />
    </Container>
  );
};
